import { ReactNode } from 'react'
import CreateCloudPool from '../../pages/CreateCloudPool'
import DownloadCloudLicenseFile from '../../pages/DownloadCloudLicenseFile'
import { createDescriptor, PageDescriptor } from '../../pages/types'
import { WebBrick } from './WebBrick'


export class CloudBrick extends WebBrick {
    get title(): string {
        return 'Instant Cloud'
    }

    key(): string { 
        return 'ic' 
    }

    get icon(): string {
        return 'solver'
    }

    *getPages(): Generator<PageDescriptor> {
        yield createDescriptor(CreateCloudPool, { })
        yield createDescriptor(DownloadCloudLicenseFile, { })
    }

    public describe(): ReactNode
    {
       return <p>The <b>Instant Cloud</b> is a service offered by Gurobi where we manage pools of Gurobi Compute Server
       machines for you.
        </p>        
    }
}
